module.exports = __webpack_public_path__ + "img/maps-coordinate.d55e548d.webp";